export default function TestimonialsSection() {
    const testimonials = [
        {
            id: 0,
            logo: "",
            profileImage: "",
            text: "I think of Pabloo as Google for Shopify merchants. Pabloo provides you with the information you search for right away."
        },
    ]

    return (
        <section className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">

                <div className="mx-auto flex flex-col gap-12 lg:flex-row max-w-2xl lg:mx-0 lg:max-w-none">
                    {cardView()}
                    {/*{cardView()}*/}
                </div>

                <div className="mx-auto flex flex-col gap-12 lg:flex-row max-w-2xl lg:mx-0 lg:max-w-none">
                    {cardView()}
                    {cardView()}
                </div>

                <div className="mx-auto flex flex-col gap-12 lg:flex-row max-w-2xl lg:mx-0 lg:max-w-none">
                    {/*{cardView()}*/}
                </div>

            </div>
        </section>
    );

    function cardView() {
        return (
            <div className="flex flex-col pb-10 sm:pb-16 lg:pr-8 lg:pb-0 xl:pr-20">
                {/*<img*/}
                {/*    alt=""*/}
                {/*    src="https://tailwindcss.com/plus-assets/img/logos/tuple-logo-gray-900.svg"*/}
                {/*    className="h-12 self-start"*/}
                {/*/>*/}
                <figure className="mt-10 flex flex-auto flex-col justify-between">
                    <blockquote className="text-lg/8 text-gray-900">
                        <p>
                            “I think of Pabloo as Google for Shopify merchants. Pabloo provides you with the information
                            you search for right away.”
                        </p>
                    </blockquote>
                    <div className="flex">
                        <div>
                            <img
                                alt="Pabloo Store Credit Cashback Review"
                                src="https://cdn.statcdn.com/static/img/testimonials/Horst-Stipp.jpg"
                                className="h-20 w-20 rounded-full bg-green-500"
                            />
                        </div>
                        <div className="text-base ml-4">
                            <div className="font-semibold text-gray-900">Judith Black</div>
                            <div className="mt-1 text-gray-500">CEO of Tuple</div>
                        </div>
                    </div>
                </figure>
            </div>
        )
    }
}
